import React, { useEffect, useState } from "react";
import "./Actualites.scss";
import Footer from "Components/Footer/Footer";
import Header from "Components/Header/Header";
import ButtonsBarDisconnected from "Components/Header/ButtonsBarDisconnected/ButtonsBarDisconnected";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import ActualitesContainer from "Components/Actualites/ActualitesContainer/ActualitesContainer";
import NavBarTab from "Components/NavBar/NavBarTab/NavBarTab";

import { useFetchGet } from "Services/api";
import { updateNews } from "Redux/Actions/newsActions";
import Creation from "Components/Actualites/Creation/Creation";
import ActualitesManagement from "Components/Actualites/ActualitesManagement/ActualitesManagement";
import { updateRessources } from "Redux/Actions/ressourcesActions";

/**
 * Permet d'accéder à la page d'actualités
 * Les actus avant connexion et pour les étudiants sont similaires
 * Les alumni et personnels peuvent proposer des actus et les gérer
 * Les admins peuvent créer des actus et des conseils et les gérer
 */
const Actualites = (props) => {
  // eslint-disable-next-line no-unused-vars
  const [activeIndex, setActiveIndex] = useState(0);
  const [filtre, setFiltre] = useState(null);
  const filtres = [
    { label: "Tous", value: "Tous" },
    { label: "Conseil", value: "Conseil" },
    { label: "Accompagnement", value: "En attente" },
    { label: "International", value: "International" },
  ];
  const dataRessources = useFetchGet("/resources/univ", props.auth.token);

  useEffect(() => {
    if (dataRessources.loaded) {
      props.handleUpdateRessources({ ressourcesData: dataRessources.data });
    }

    if (props.states.statesData.length > 0) {
      const dataNewsStatusModified = props.states.statesData.map((state) => {
        return {
          id: state.id,
          statusLabel: state.statusLabel,
          name: state.statusLabel,
        };
      });
      const listOfStatus = ["Brouillon", "Refusé", "En Attente", "Publié"];

      props.handleUpdateNews({
        etats: dataNewsStatusModified.filter(
          (state) => listOfStatus.indexOf(state.name) !== -1
        ),
      });
    }
  }, [props.states.statesData.length, dataRessources.loaded]);

  return (
    <div className="actus">
      {
        //? Affichage header si connecté :
        props.auth.isConnected ? (
          (() => {
            switch (true) {
              case props.auth.isAdmin:
                return (
                  <Header noImage={false}>
                    <NavBarTab
                      select="actuadmin"
                      activeIndex={props.items.activeItemActuAdmin}
                      items={props.items.itemsActuAdmin}
                    />
                  </Header>
                );
              case props.auth.userConnected.userRoles.some(
                (role) => role.roleName == "ROLE_ETUDIANT"
              ) && !props.auth.isCreator:
                return <Header noImage={true} />;
              case props.auth.userConnected.userRoles.some(
                (role) =>
                  role.roleName == "ROLE_ALUMNI" ||
                  role.roleName == "ROLE_PERSONNEL_UNIVERSITE" ||
                  role.roleName.includes("REDACTEUR_ACTU")
              ):
                return (
                  <Header noImage={false}>
                    <NavBarTab
                      select="actu"
                      activeIndex={props.items.activeItemActu}
                      items={props.items.itemsActu}
                    />
                  </Header>
                );
              default:
                return <Header noImage={true} />;
            }
          })()
        ) : (
          //? Si déconnecté :
          <Header noImage={true}>
            <ButtonsBarDisconnected />
          </Header>
        )
      }
      {/* Affichage de ActualitesContainer : */}
      {
        //? SI déconnecté
        !props.auth.isConnected ? (
          <ActualitesContainer
            filtre={filtre}
            setFiltre={setFiltre}
            filtres={filtres}
          />
        ) : (
          //? Si connecté :
          (() => {
            switch (true) {
              case props.auth.isAdmin &&
                props.items.activeItemActuAdmin ==
                  props.items.itemsActuAdmin.findIndex(
                    (v) => v.label == "Toutes les actus/conseils"
                  ):
                return (
                  <ActualitesContainer
                    activeIndex={props.items.itemsActuAdmin.findIndex(
                      (v) => v.label == "Toutes les actus/conseils"
                    )}
                    setActiveIndex={setActiveIndex}
                    items={props.items.itemsActuAdmin}
                    filtre={filtre}
                    setFiltre={setFiltre}
                    filtres={filtres}
                  />
                );
              case props.auth.userConnected.userRoles.some(
                (role) => role.roleName == "ROLE_ETUDIANT"
              ) && !props.auth.isCreator:
                return (
                  <ActualitesContainer
                    filtre={filtre}
                    setFiltre={setFiltre}
                    filtres={filtres}
                  />
                );
              case props.auth.userConnected.userRoles.some(
                (role) =>
                  role.roleName == "ROLE_ALUMNI" ||
                  role.roleName == "ROLE_PERSONNEL_UNIVERSITE" ||
                  role.roleName.includes("REDACTEUR_ACTU")
              ) &&
                props.items.activeItemActu ==
                  props.items.itemsActu.findIndex(
                    (v) => v.label == "Toutes les actus"
                  ):
                return (
                  <ActualitesContainer
                    activeIndex={props.items.itemsActu.findIndex(
                      (v) => v.label == "Toutes les actus"
                    )}
                    setActiveIndex={setActiveIndex}
                    items={props.items.itemsActu}
                    filtre={filtre}
                    setFiltre={setFiltre}
                    filtres={filtres}
                  />
                );
            }
          })()
        )
      }
      {/* proposer une actu ou créer une actu/conseil ---------------------- */}
      {props.auth.userConnected &&
        (() => {
          switch (true) {
            case props.auth.isAdmin &&
              props.items.activeItemActuAdmin ==
                props.items.itemsActuAdmin.findIndex(
                  (v) => v.label == "Créer une actu/conseil"
                ):
              return (
                <Creation
                  activeIndex={props.items.itemsActuAdmin.findIndex(
                    (v) => v.label == "Créer une actu/conseil"
                  )}
                  setActiveIndex={setActiveIndex}
                  items={props.items.itemsActuAdmin}
                />
              );
            case props.auth.userConnected.userRoles.some(
              (role) =>
                role.roleName == "ROLE_ALUMNI" ||
                role.roleName == "ROLE_PERSONNEL_UNIVERSITE" ||
                role.roleName.includes("REDACTEUR_ACTU")
            ) &&
              props.items.activeItemActu ==
                props.items.itemsActu.findIndex(
                  (v) => v.label == "Proposer une actu"
                ):
              return (
                <Creation
                  activeIndex={props.items.itemsActu.findIndex(
                    (v) => v.label == "Proposer une actu"
                  )}
                  setActiveIndex={setActiveIndex}
                  items={props.items.itemsActu}
                />
              );
            default:
              return null;
          }
        })()}
      {/* gestion des actus/conseils ------------------ */}
      {props.auth.userConnected &&
        (() => {
          switch (true) {
            case props.auth.isAdmin &&
              props.items.activeItemActuAdmin ==
                props.items.itemsActuAdmin.findIndex(
                  (v) => v.label == "Gérer les actus/conseils"
                ):
              return (
                <ActualitesManagement
                  activeIndex={props.items.itemsActuAdmin.findIndex(
                    (v) => v.label == "Gérer les actus/conseils"
                  )}
                  setActiveIndex={setActiveIndex}
                  items={props.items.itemsActuAdmin}
                />
              );
            case props.auth.userConnected.userRoles.some(
              (role) =>
                role.roleName == "ROLE_ALUMNI" ||
                role.roleName == "ROLE_PERSONNEL_UNIVERSITE"
            ) &&
              props.items.activeItemActu ==
                props.items.itemsActu.findIndex(
                  (v) => v.label == "Gérer mes actus"
                ):
              return (
                <ActualitesManagement
                  activeIndex={props.items.itemsActu.findIndex(
                    (v) => v.label == "Gérer mes actus"
                  )}
                  setActiveIndex={setActiveIndex}
                  items={props.items.itemsActu}
                />
              );
            default:
              return null;
          }
        })()}
      <Footer />
    </div>
  );
};

Actualites.propTypes = {
  auth: PropTypes.object,
  items: PropTypes.object,
  handleUpdateNews: PropTypes.func,
  news: PropTypes.object,
  handleUpdateRessources: PropTypes.func,
  ressources: PropTypes.object,
  states: PropTypes.object,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  items: state.items,
  news: state.news,
  ressources: state.ressources,
  states: state.states,
});

const mapDispatchToProps = (dispatch) => ({
  handleUpdateNews: (value) => {
    dispatch(updateNews(value));
  },
  handleUpdateRessources: (value) => {
    dispatch(updateRessources(value));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Actualites);
